import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import 'devextreme/data/odata/store';
import { lastValueFrom, BehaviorSubject, elementAt, Observable } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NotifyService } from './hr/notify.service';
import { DatePipe } from '@angular/common';
import { ScreenNameEnum } from 'src/app/pages/sales/SalesInterfaces/screenenum';


@Injectable({
  providedIn: 'root'
})
export class genericCustomStoreService {
  //permission
  session: any = sessionStorage.getItem("data");
  data = JSON.parse(this.session);
  navihationMenu = this.data?.navihationMenu

  //
  private url: string;
  public sessiondata = new BehaviorSubject<[]>([])
  public $NavigationMenu = new BehaviorSubject<number>(0)
  //comuncation different module
  $PaymentDropDownsValues = new BehaviorSubject<{}[]>([])
  $HOMETAB = new BehaviorSubject<boolean>(false)
  $UseDafterCode = new BehaviorSubject<boolean>(false)
  $UseIsItemNameAr = new BehaviorSubject<boolean>(true)

  $Datefrom = new BehaviorSubject<string>('')

  $Dateto = new BehaviorSubject<string>('')
  $Ids = new BehaviorSubject<number[]>([]);

  $Url = new BehaviorSubject<string>('');
  //home
  $home = new BehaviorSubject<{}[]>([])
  public seturl(value: string) {
    this.url = value;
  }
  dataSource: any;
  $filterstore = new BehaviorSubject<number>(0);
  //routing permission
  $ROUTINGPERMISSION = new BehaviorSubject<{}[]>([])

  $filterstatus = new BehaviorSubject<number | null>(null);

  // private handleError: HandleError;
  public customDataSource: any;
  constructor(private http: HttpClient, public DatePipe: DatePipe, public translatee: TranslateService, public NotifyService: NotifyService) {
    // this.handleError = httpErrorHandler.createHandleError('ObjectService');    
  }

  public submit(queryParams?: any) {
    this.customDataSource = new CustomStore({
      key: 'id',
      loadMode: 'raw',

      load: () => {

        const url = queryParams
          ? `${environment.apiRoot}/api/${this.url}/all?${queryParams}`
          : `${environment.apiRoot}/api/${this.url}/all`;

        return lastValueFrom(this.http.get(url))
          .catch(() => { throw 'Data loading error' });
      },
      insert: (values) => {
        return this.http.post<any>(`${environment.apiRoot}/api/${this.url}/Add`, values).pipe(
        ).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('add')
        })
      },

      update: (key, values) => {
        return this.http.put(`${environment.apiRoot}/api/${this.url}/Update`, values).toPromise().then(res => {
          this.NotifyService.notifyfun('edit')
          return res
        }, (err => {
          return err
        }))
      },
      remove: (key) => {
        return this.http.delete(`${environment.apiRoot}/api/${this.url}/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('delete')

        })
      }
    });
  }

  public submitWithParams(queryParams: any) {

    this.customDataSource = new CustomStore({
      key: 'id',
      loadMode: 'raw',

      load: () => {

        const params = new URLSearchParams();

        Object.keys(queryParams).forEach(key => {
          if (queryParams[key] !== undefined && queryParams[key] !== null) {
            params.append(key, queryParams[key]);
          }
        });

        const url = `${environment.apiRoot}/api/${this.url}/all?${params.toString()}`;

        return lastValueFrom(this.http.get(url))
          .catch(() => { throw 'Data loading error'; });
      },

      insert: (values) => {

        Object.assign(values, queryParams);

        return this.http.post<any>(
          `${environment.apiRoot}/api/${this.url}/Add`,
          values
        ).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('add');
        });
      },

      update: (key, values) => {

        Object.assign(values, queryParams);

        return this.http.put(
          `${environment.apiRoot}/api/${this.url}/Update`,
          values
        ).toPromise().then(res => {
          this.NotifyService.notifyfun('edit');
          return res;
        });
      },

      remove: (key) => {

        return this.http.delete(
          `${environment.apiRoot}/api/${this.url}/Delete?id=${encodeURIComponent(key)}`
        ).toPromise().then(() => {
          this.NotifyService.notifyfun('delete');
        });

      }

    });

  }

  public getdropdowndataWithParams(
    url: string,
    queryParams: any,
    endpoint: string = 'GetDropDown',
    state: string = 'false'
  ) {

    let params = new HttpParams();

    Object.keys(queryParams).forEach(key => {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        params = params.set(key, queryParams[key]);
      }
    });

    return this.http.get(
      `${environment.apiRoot}/api/${url}/${endpoint}`,
      {
        headers: { state },
        params
      }
    );
  }
  getdropdown(url: string) {
    return this.http.get(`${environment.apiRoot}/api/${url}/all`)
  }
  getEmployeeInformation() {
    return this.http.get(`${environment.apiRoot}/api/hr/employee/GetDropDown/EmployeeInformation`)
  }
  checkIsNewTab(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiRoot}/api/Settings/CheckIsNewTab`);
  }
  CheckUseDafterCode(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiRoot}/api/Settings/CheckUseDafterCode`);
  }
  CheckUseIsItemNameAr(): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiRoot}/api/Settings/CheckUseIsItemNameAr`);
  }

  getdropdowndata(url: string, endpoint: string = 'GetDropDown', state: string = 'false') {
    return this.http.get(`${environment.apiRoot}/api/${url}/${endpoint}`, { headers: { state } })
  }
  // getdropdowndata(url: string, endpoint: string = 'GetDropDown', state: string = 'false') {
  //   return this.http.get(`${environment.apiRoot}/api/${url}/${endpoint}`, { headers: { state } })
  // }

  getlastcodedata(url: string, endpoint: string = 'GetLastCode', state: string = 'false') {
    return this.http.get(`${environment.apiRoot}/api/${url}/${endpoint}`, { headers: { state } });
  }

  dropdown(url: string) {
    return this.http.get(`${environment.apiRoot}/api/${url}`)
  }
  checkVacation(dto: any) {
    return this.http.post<any>(`${environment.apiRoot}/api/VacationRequest/Check`, dto);
  }
  Addvacation(dto: any) {
    return this.http.post<any>(`${environment.apiRoot}/api/VacationRequest/add`, dto);
  }
  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
  }
  getdatabyid(id: number, path: string) {
    return this.http.get(`${environment.apiRoot}/api/${path}/GetById/${id}`)
  }
  GetVacationRequests() {
    return this.http.get(`${environment.apiRoot}/api/VacationRequest/all`);
  }

  ApproveVacation(dto: any) {
    return this.http.put(`${environment.apiRoot}/api/VacationRequest/Approve`, dto);
  }


  changepassword(data: {}) {
    return this.http.put(environment.apiRoot + `/api/User/ResetPasswordUser`, data)
  }

  create(controller: string, data: any) {
    return this.http.post(environment.apiRoot + `/api/${controller}`, data);
  }

  get(url: string) {
    return this.http.get(`${environment.apiRoot}${url}`);
  }

  getJobTitelsBasedOnMangmentId(id: number) {
    return this.http.get(`${environment.apiRoot}/api/JobTitleStructure/JobTitles/${id}`);
  }

  createByUrl(url: string, data: any) {
    return this.http.post(`${environment.apiRoot}${url}/Add`, data);
  }

  onEditorPreparing(e: any) {
    if (e.parentType == 'dataRow') {
      e.editorOptions.onInitialized = function (arg: any) {
        arg.component.registerKeyHandler("escape", function (arg: any) {
          e.component.cancelEditData();
        });
      }
    }
  }

  addrow(name: string) {
    let actiontranslate = this.translatee.instant('tableinfo.addbutton');
    let nametranslate = this.translatee.instant(name);
    return `${actiontranslate} ${nametranslate}`
  }

  translatefunction(name: string) {
    return this.translatee.instant(name);
  }
  getgovernorates(value: number) {
    return this.http.get(`${environment.apiRoot}/api/Fillters/FillterAdress?Id=${value}`)
  }

  update(url: string, data: any) {
    return this.http.put(`${environment.apiRoot}/api/${url}`, data);
  }

  // update(url:string, data:any) {
  //   return this.http.put(`${environment.apiRoot}/api/${url}`, data);
  // }

  getcdcsetting() {
    return this.http.get(`${environment.apiRoot}/api/Settings/CheckCdcSetting`)
  }
  GetLastCode(value: any) {

    return this.http.get(`${environment.apiRoot}/api/${value}/GetLastCode`)
  }
  GenerateCode(value: any) {

    return this.http.get(`${environment.apiRoot}/api/${value}/GenerateCode`)
  }
  getPermisstionsTypes(url: string, employeeId: number) {
    return this.http.get(`${environment.apiRoot}/api/${url}?EmployeeId=${employeeId}`)
  }
  sendreportmail(reporturl: any) {
    return this.http.get(`${environment.apiRoot}/api/ReportsType/SendReportMail?ReportUrl=${reporturl}`)
  }
  getpermissionactions(controller: string, action: string): boolean {

    const sessiondata = sessionStorage.getItem("data") as string;
    const firstdata = JSON.parse(sessiondata);
    const data = firstdata?.navihationMenu
    const targetModule = data.find((x: any) => x.nameEn === controller);

    const updateAcceptAction = targetModule?.permissionActions.find((p: any) => p.name === action);
    if (updateAcceptAction.visable == true) {
      return true;


    }
    else {
      return false;
    }

  }

  covertDateToTime(value: any) {
    return this.DatePipe.transform(value, 'HH:mm:ss')
  }

  returnPermission(controller: string, action: string) {
    let itemFound = this.returnItem(controller)
    let actions = itemFound?.permissionActions.find((actions: { name: string }) => {
      return actions.name == action
    })
    return actions?.visable
  }

  returnItem(controller: string) {
    return this.navihationMenu.find((res: { controllerName: string }) => {
      return res.controllerName == controller
    })
  }

  uploaddPhoto(data: FormData) {
    return this.http.post(environment.apiRoot + `/api/CdcExpense/UploadAttachment`, data);
  }



  //payment on edit
  returneditpayment(paymentMethods: any, paymentDropDown: any) {

    paymentMethods.forEach((element: { paymentId: number, paymentType: number, guid: string, currency: number }) => {
      this.returnpayment(paymentDropDown, element).then((res: any) => {
        console.log(res, "res")
        element.guid = res?.guid
        element.currency = res?.currencyId
      })
    });
    return paymentMethods
  }

  returnpayment(paymentDropDown: any, element: { paymentId: number, paymentType: number }) {
    return new Promise(resolve => {
      let data: any = paymentDropDown.find((res: { id: number, paymentType: number }) => {
        return res.id == element.paymentId && res.paymentType == element.paymentType
      })
      resolve(data)
    })
  }


  searchItemsGroup(ItemGroupId?: any, ItemId?: any, MainDataColorsId?: any, MainDataSizingId?: any, MainDataScreeningId?: any, ManufacturerCompanyId?: any) {
    let params = new HttpParams()
    if (ItemGroupId) params = params.append('ItemGroupId', ItemGroupId)
    if (ItemId) params = params.append('ItemId', ItemId)
    if (MainDataColorsId) params = params.append('MainDataColorsId', MainDataColorsId)
    if (MainDataSizingId) params = params.append('MainDataSizingId', MainDataSizingId)
    if (MainDataScreeningId) params = params.append('MainDataScreeningId', MainDataScreeningId)
    if (ManufacturerCompanyId) params = params.append('ManufacturerCompanyId', ManufacturerCompanyId)
    return this.http.get(`${environment.apiRoot}/api/Items/Search`, { params })
  }


  Delete(id: any, url: string) {
    return this.http.delete(`${environment.apiRoot}/api/${url}/Delete?Id=${id}`)

  }

  DeleteByUrl(url: string) {
    return this.http.delete(`${environment.apiRoot}/api/${url}`)

  }

  AddByUrl(url: string, data: any) {
    return this.http.post(`${environment.apiRoot}/api/${url}`, data);
  }

  GetAllowedHolidayTypesDropDown(employeeId: any) {
    return this.http.get(`${environment.apiRoot}/api/HolidayType/AllowedHolidayTypesDropDown?employeeId=${employeeId}`);
  }


  GetGridConfigration(documentname: string) {

    const screenname = this.getEnumValueByScreenName(documentname)

    return this.http.get(`${environment.apiRoot}/api/GridConfigurations/GetByScreenNameEnum?screenNameEnum=${screenname}`)
  }

  updategridconfigration(configration: any, documentname: string) {

    const screenenum = this.getEnumValueByScreenName(documentname)
    const data = {

      screenNameEnum: screenenum,
      configurations: configration


    }
    return this.http.put(environment.apiRoot + `/api/GridConfigurations/Update`, data);
  }

  getEnumValueByScreenName(screenName: string): number | undefined {
    // Iterate through the keys and values of the enum
    for (const [key, value] of Object.entries(ScreenNameEnum)) {
      // Check if the key matches the screenName and ensure the value is a number
      if (key === screenName && typeof value === 'number') {
        return value;
      }
    }
    return undefined;
  }

  GetEmployeeDetails(FromDate?: string, ToDate?: string) {
    let params = new HttpParams();

    if (FromDate) {
      params = params.set('FromDate', FromDate);
    }

    if (ToDate) {
      params = params.set('ToDate', ToDate);
    }

    return this.http.get(`${environment.apiRoot}/api/Employeepage/all`, { params });
  }


  getPermissionsForRoute(routeName: string): { allowAdding: boolean; allowUpdating: boolean; allowDeleting: boolean } {
    let permissions = { allowAdding: false, allowUpdating: false, allowDeleting: false };

    try {

      // ✅ Always get fresh data
      const sessionData: any = sessionStorage.getItem('data');
      const parsedData = JSON.parse(sessionData || '{}');
      const navigationMenu = parsedData?.navihationMenu || [];
      const currentRoute = routeName.split('?')[0].trim().toLowerCase();
      const matchedMenu = navigationMenu.find((menu: any) => {
        const name = (menu.externalUrl || '').trim().toLowerCase();
        return name === currentRoute;
      });

      if (matchedMenu) {
        const permissionActions: PermissionAction[] = matchedMenu.permissionActions || [];

        permissions.allowAdding = permissionActions.some((action: PermissionAction) => action.name === 'Add/Create' && action.visable);
        permissions.allowDeleting = permissionActions.some((action: PermissionAction) => action.name === 'Delete' && action.visable);
        permissions.allowUpdating = permissionActions.some((action: PermissionAction) => action.name === 'Update' && action.visable);
        console.log(' permissions from service:', {
          allowAdding: permissions.allowAdding,
          allowUpdating: permissions.allowUpdating,
          allowDeleting: permissions.allowDeleting
        });
      } else {
        console.warn("No matching menu item found for route:", currentRoute);
      }
    } catch (error) {
      console.warn('Permission parsing failed:', error);
    }

    return permissions;
  }

  GetScreenDetails(documentname: string) {

    return this.http.get(`${environment.apiRoot}/api/DocumentaryCycle/${documentname}/GetScreenDetails`);

  }

  AddVacationBulk(dto: any) {
    return this.http.post(`${environment.apiRoot}/api/VacationRequest/AddBulk`, dto);
  }

  importJournalExcel(formData: FormData) {
    return this.http.post(
      `${environment.apiRoot}/api/JournalEntry/ImportExcel`,
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  ApproveJournalEntry(dto: any) {
    return this.http.put(
      `${environment.apiRoot}/api/JournalEntry/Approve`,
      dto
    );
  }
  // createPaginationStore(url: string, extraParams?: any) {

  //   return new CustomStore({

  //     key: "id",

  //     load: (loadOptions: any) => {

  //       const skip = loadOptions.skip || 0
  //       const take = loadOptions.take || 50

  //       const pageNumber = Math.floor(skip / take) + 1

  //       let search = ""

  //       if (loadOptions.searchValue) {
  //         search = loadOptions.searchValue
  //       }

  //       if (loadOptions.filter) {
  //         search = loadOptions.filter[0][2]
  //       }

  //       let params = new HttpParams()
  //         .set("PageNumber", pageNumber)
  //         .set("PageSize", take)
  //         .set("Search", search)


  //       if (extraParams) {
  //         Object.keys(extraParams).forEach(key => {
  //           params = params.set(key, extraParams[key])
  //         })
  //       }

  //       return this.http.get(`${environment.apiRoot}/api/${url}`, { params })
  //         .toPromise()
  //         .then((res: any) => ({
  //           data: res.items,
  //           totalCount: res.totalCount
  //         }))
  //     }
  //   })
  // }

  createPaginationStore(url: string, extraParams?: any, getByKeyId?: () => number) {

    return new CustomStore({

      // 🔴 FIX 1: use correct key
      key: "id",

      load: (loadOptions: any) => {

        const skip = loadOptions.skip || 0;
        const take = loadOptions.take || 50;

        const pageNumber = Math.floor(skip / take) + 1;

        let search = "";

        if (loadOptions.searchValue) {
          search = loadOptions.searchValue;
        }

        if (loadOptions.filter) {
          search = loadOptions.filter[0][2];
        }

        let params = new HttpParams()
          .set("PageNumber", pageNumber)
          .set("PageSize", take)
          .set("Search", search);

        if (extraParams) {
          Object.keys(extraParams).forEach(key => {
            params = params.set(key, extraParams[key]);
          });
        }

        return this.http
          .get(`${environment.apiRoot}/api/${url}`, { params })
          .toPromise()
          .then((res: any) => ({
            data: res.items,
            totalCount: res.totalCount
          }));
      },

      // 🔥🔥🔥 FIX 2: ADD THIS

      // byKey: (key: any) => {
      //         if (!key) return Promise.resolve(null);

      //         // 👉 adjust endpoint if needed
      //         return this.http
      //           .get(`${environment.apiRoot}/api/${url}/GetByGuid`, {
      //             params: new HttpParams().set("guid", key)
      //           })
      //           .toPromise()
      //           .then((res: any) => res);
      //       }

      byKey: (key: any) => {

        if (!key) {
          return Promise.resolve(null);
        }
        const id = getByKeyId ? getByKeyId() : key;

        const controller = url.split('/')[0];

        const params = new HttpParams()
          .set("id", id)
          .set("type", extraParams?.Type);

        return this.http
          .get(`${environment.apiRoot}/api/${controller}/GetAccountByTypeAndId`, {
            params
          })
          .toPromise()
          .then((res: any) => {
            console.log("byKey", key);
            console.log("byKey result", res);
            return res;
          });

      }
    });
  }


  createEntityStore(entity: string, extraParams?: any) {
    return new CustomStore({
      key: "id",

      load: (loadOptions: any) => {
        // 1. Handle Pagination
        const skip = loadOptions.skip || 0;
        const take = loadOptions.take || 10; // Default to 10 for dropdowns
        const pageNumber = Math.floor(skip / take) + 1;

        // 2. Robust Search/Filter Parsing
        let searchText = "";

        if (loadOptions.searchValue) {
          // Direct search value from lookup/selectbox
          searchText = loadOptions.searchValue;
        } else if (loadOptions.filter) {
          // Case A: Simple filter ["nameEn", "contains", "abc"]
          if (Array.isArray(loadOptions.filter) && typeof loadOptions.filter[0] === 'string') {
            searchText = loadOptions.filter[2];
          }
          // Case B: Nested filter [["nameEn", "contains", "abc"], "and", [...]]
          else if (Array.isArray(loadOptions.filter) && Array.isArray(loadOptions.filter[0])) {
            searchText = loadOptions.filter[0][2];
          }
        }

        // 3. Build HttpParams
        let params = new HttpParams()
          .set("PageNumber", pageNumber.toString())
          .set("PageSize", take.toString())
          .set("Search", searchText || "");

        // 4. Append extra parameters if provided
        if (extraParams) {
          Object.keys(extraParams).forEach(key => {
            if (extraParams[key] !== undefined && extraParams[key] !== null) {
              params = params.set(key, extraParams[key].toString());
            }
          });
        }

        // 5. Execute Request
        return this.http
          .get(`${environment.apiRoot}/api/${entity}/GetPaged`, { params })
          .toPromise()
          .then((res: any) => {
            // IMPORTANT: Ensure 'items' and 'totalCount' match your API's JSON casing exactly
            return {
              data: res.items || [],
              totalCount: res.totalCount || 0
            };
          })
          .catch(err => {
            console.error("Data loading error", err);
            throw err;
          });
      },

      byKey: (key: any) => {
        if (key === undefined || key === null || key === '') {
          return Promise.resolve(null);
        }

        return this.http
          .get(`${environment.apiRoot}/api/${entity}/GetById/${key}`)
          .toPromise()
          .then((res: any) => {
            // If your API returns a wrapped response, adjust accordingly (e.g., res.data)
            return res.data || res.result || res;
          });
      }
    });
  }


}
//gridconfigration 

interface PermissionAction {
  id: number;
  name: string;
  visable: boolean;
}